import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import { AppLayout } from '@/pages/_layout/app-layout'

import { LayoutSkeleton } from '../lazy'

const Avail = lazy(async () => await import('../../pages/avail'))

const BookingBook = lazy(async () => await import('../../pages/booking'))
const BookingAdd = lazy(
  async () => await import('../../pages/booking/booking-add'),
)

const UploadedFiles = lazy(
  async () => await import('../../pages/batch-reservations/files/files'),
)

const BatchReservationsRequests = lazy(
  async () => await import('../../pages/batch-reservations/requests/requests'),
)
const HotelDetail = lazy(async () => await import('../../pages/hotel/detail'))

const BookinDetail = lazy(
  async () => await import('../../pages/booking/booking-detail'),
)

const Request = lazy(async () => await import('../../pages/request/requests'))

const BookingEdit = lazy(
  async () => await import('../../pages/booking/booking-edit'),
)

export function RoutesApp(): JSX.Element {
  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <div className="mt-0">
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route path="" element={<Avail />} />
            <Route path="booking/payment" element={<BookingAdd />} />
            <Route path="booking/edit" element={<BookingEdit />} />
            {/* <Route path="/booking/edit" element={<BookingEditNew />} /> */}
            <Route path="booking/myReservations" element={<BookingBook />} />
            <Route path="hotel/detail" element={<HotelDetail />} />
            <Route path="booking/detail" element={<BookinDetail />} />
            <Route path="requesties" element={<Request />} />

            {/* Batch Reservations */}
            <Route
              path="batch-reservations/uploaded-files"
              element={<UploadedFiles />}
            />

            <Route
              path="batch-reservations/requests"
              element={<BatchReservationsRequests />}
            />
          </Route>
        </Routes>
      </div>
    </Suspense>
  )
}
